import { useEffect } from 'react';
import { useWeb3 } from '../context/Web3Context';

const API = process.env.REACT_APP_BACKEND_URL;
const REF_STORAGE_KEY = 'b4p_ref_code';

/**
 * Mounted at the top of the App router.
 * - Detects ?ref=XXXX in the URL → stores in localStorage + logs a click (rewards the sponsor +1 B4P / 24h)
 * - When the user's wallet connects, attributes the visitor to the stored ref (one-time, idempotent)
 */
export default function RefTracker() {
    const { address } = useWeb3();

    // 1. On mount / URL change: capture ?ref= and log click
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const ref = params.get('ref');
        if (ref) {
            try { localStorage.setItem(REF_STORAGE_KEY, ref); } catch (e) { /* ignore */ }
            // Fire-and-forget click log (server fingerprints by IP/UA + 24h cooldown)
            fetch(`${API}/api/social-sharing/click`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ref_code: ref, target_path: window.location.pathname }),
            }).catch(() => {});
        }
    }, []);

    // 2. When wallet connects, attribute visitor to stored ref (one-time per address)
    useEffect(() => {
        if (!address) return;
        let storedRef = null;
        try { storedRef = localStorage.getItem(REF_STORAGE_KEY); } catch (e) { /* ignore */ }
        if (!storedRef) return;
        fetch(`${API}/api/social-sharing/attribute`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ visitor_address: address, ref_code: storedRef }),
        }).catch(() => {});
    }, [address]);

    return null;
}
